<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <SelectMultipleInput
        :question="$t('safety.question')"
        :image="require('@/assets/safety.png')"
        :selections="selections"
        :clicked-callback="onSelect"
        :next="next"
      ></SelectMultipleInput>
      <a
        @click="$router.push(getPrevStepUrl(step, $i18n.locale))"
        class="back-btn"
        >{{ $t("back") }}</a
      >
    </div>
  </div>
</template>

<script>
  import {mapMutations} from "vuex";
  import CalculatorHeading from "../../components/CalculatorHeading";
  import {getStepIndex} from "@/utils/steps.js";
  import {getPrevStepUrl, goToNextStep, redirectToUnselectedStepIfAny} from "../../utils/steps";
  import SelectMultipleInput from "../../components/SelectMultipleInput";

  export default {
  name: "Safety",
  components: { SelectMultipleInput, CalculatorHeading },
  data() {
    return {
      step: getStepIndex("safety"),
      getPrevStepUrl: getPrevStepUrl,
      selections: [
        {
          name: this.$t("safety.smoke"),
          selected: this.$store.state.data.smoke,
          update: value => this.updateSmoke(value)
        },
        {
          name: this.$t("safety.leakage"),
          selected: this.$store.state.data.leakage,
          update: value => this.updateLeakage(value)
        }
      ]
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateSmoke", "updateLeakage"]),
    onSelect(selection) {
      selection.update(!selection.selected);
      selection.selected = !selection.selected;
    },
    next() {
      goToNextStep(this.step, this.$i18n.locale, this.$router);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../common/_variables.scss";
h4 {
  color: $color-primary;
}
.back-btn {
  margin-top: 60px;
}
</style>
